import React from 'react';
// import './FormComponent.scss';

import { Theme, useTheme, styled as matStyles } from '@mui/material/styles';

import {
    Popper,
    Autocomplete,
    TextField,
    CircularProgress,
    Card,
} from '@mui/material';

import { AutoCompleteDropdownInterface } from '../../Models/Common/FormFieldComponentInterfaces';

import { IconCircleCheckFilled } from '@tabler/icons-react';

import LocalStorageHelper from '../../Utilities/Helpers/LocalStorageHelper';

import CustomFormTitle from './CustomFormTitle';
import styled from 'styled-components';

const StyledPopper: any = matStyles(Popper)(({ theme }) => ({
    '& .MuiAutocomplete-groupLabel': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.black,
    },
}));

const StyledContainer = styled.div`
    // width: auto;
    width: -webkit-fill-available;

    .MuiInputBase-root {
        font-size: 0.9rem !important;
        color: ${props => props.theme.primaryText};

        &::placeholder {
            color: var(--fieldFocusedBorderPrimaryColor);
            opacity: 0.8;
        }
    }

    .MuiTextField-root {
        margin-top: 0px !important;
        background: ${props => props.theme.fieldBackgroundColor};
    }

    .MuiOutlinedInput-root {
        padding: 0px !important;
    }

    .MuiInputBase-input {
        padding:  7px 8px !important;
    }

    .MuiFormHelperText-root {
        margin-left: 0px !important;
    }
`;

const DropdownContainer = styled.div <{ $darkMode?: boolean; $position?: string; }>`
    display: flex;
    justify-content: space-between;

    .MuiAutocomplete-root.MuiAutocomplete-hasPopupIcon {
        width: -webkit-fill-available;

        .MuiFormControl-root.MuiFormControl-fullWidth.MuiTextField-root {
            .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot {
                border-radius: ${props => props.$position == 'start' ? '0px 4px 4px 0px' : (props.$position == 'end' ? '4px 0px 0px 4px' : '4px')}!important;

                // .MuiOutlinedInput-notchedOutline {
                //     border-left: none;
                //     border-right: none;
                // }

                .Mui-disabled {
                    // background-color: ${(props) => (props.theme.disabled)};
                    background-color: ${(props) => (props.$darkMode ? '#242728' : '#e9ebec')};
                    -webkit-text-fill-color: var(--disabledFieldFontColor) !important;
                }
            }
        }
    }
`;

const SideContainer = styled(Card) <{ $darkMode?: boolean; $position?: string; }>`
    // background: #e9ebec !important;
    border: 1px solid;
    border-left: ${props => props.$position == 'start' ? '1px solid' : 'none'};
    border-right: ${props => props.$position == 'start' ? 'none' : '1px solid'};
    border-radius: ${props => props.$position == 'start' ? '4px 0px 0px 4px' : '0px 4px 4px 0px'}!important;
    box-shadow: none !important;
    height: 35px;
    font-size: .775rem !important;
    font-weight: 400 !important;
    align-content: center;
    padding: 0px 20px 0px 15px;
    color: ${props => props.theme.primaryText};
`;

const AutoCompleteDropdown = (fieldProps: AutoCompleteDropdownInterface) => {
    //Variables
    let isDarkMode = LocalStorageHelper.isDarkMode();
    const theme = useTheme();

    let fValue: any = Array.isArray(fieldProps.fieldValue) ? fieldProps.fieldValue : [fieldProps.fieldValue];
    let message: any = (fieldProps.errorMessages && fieldProps.errorMessages[fieldProps.name] ?
        fieldProps.errorMessages[fieldProps.name] : null
    );
    let selectedValues: any = (fieldProps?.options?.length > 0 ?
        fieldProps?.options?.filter((option: any) => fValue.includes(option.id))
        : []);

    selectedValues = (fieldProps.multiple ?
        (selectedValues.length > 0 ? selectedValues : []) : (selectedValues.length > 0 ? selectedValues[0] : null)
    );


    //Rendering UIs
    const errorMsg = (fieldProps.errorMessages ? fieldProps.errorMessages[fieldProps.name] : null) ?? null;
    // const errorMsg = 'test error message';

    const renderDropDown = () => {
        return <Autocomplete {...{
            id: (fieldProps.multiple ? "multiple-limit-tags" : "tags-outlined") + " " + fieldProps.title,
            multiple: fieldProps.multiple,
            limitTags: fieldProps.limitTags,
            options: fieldProps?.options ?? [],
            getOptionLabel: (option: any) => option.title ?? option.name,
            value: selectedValues,
            disabled: fieldProps.disabled,
            PopperComponent: StyledPopper,
            loading: fieldProps?.isLoadingDropdown ? fieldProps.isLoadingDropdown : false,
            // disableCloseOnSelect: fieldProps.isDisableCloseOnSelect,
            disableCloseOnSelect: fieldProps.multiple,
            renderInput: (params: any) => {
                return <TextField
                    {...params}
                    variant="outlined"
                    error={errorMsg != null && errorMsg != ""}
                    helperText={(!fieldProps?.hideErrorMessage ? (errorMsg ?? '') : '')}
                    placeholder={fieldProps.placeholder}
                    slotProps={{
                        input: {
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {fieldProps?.isLoadingDropdown ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        },
                    }} />
            },
            onChange: (event: any, newValue: any) => {
                fieldProps.handleOnChange(newValue);
            },
        }} />
    }

    return <StyledContainer className={"autoCompleteDropdownContainer " + fieldProps?.fieldClassName ?? ""}>

        {/* ---------TITLE---------- */}
        {!fieldProps.hideLabel && <CustomFormTitle title={fieldProps.title}
            required={fieldProps.required}
            hideLabel={fieldProps.hideLabel}
            exclamationHoverItemDisplayText={fieldProps.exclamationHoverItemDisplayText} />}

        {/* ---------DROPDOWN---------- */}

        <DropdownContainer $darkMode={isDarkMode} $position={fieldProps?.sideContentPosition}>
            {(fieldProps?.sideContent && fieldProps?.sideContentPosition == "start") && <SideContainer sx={{backgroundColor: 'disabled', borderColor: (errorMsg != null && errorMsg != "" ? 'customBorder.errorBorder' : 'customBorder.main'), color: 'primaryText'}} $position={fieldProps.sideContentPosition}>{fieldProps.sideContent}</SideContainer>}
            {renderDropDown()}
            {(fieldProps?.sideContent && fieldProps?.sideContentPosition == "end") && <SideContainer sx={{backgroundColor: 'disabled', borderColor: (errorMsg != null && errorMsg != "" ? 'customBorder.errorBorder' : 'customBorder.main'), color: 'primaryText'}} $position={fieldProps.sideContentPosition}>{fieldProps.sideContent}</SideContainer>}
        </DropdownContainer>
    </StyledContainer>
}

export default AutoCompleteDropdown;